import moment from 'moment';
import { forEach, get, cloneDeep } from 'lodash';
import { GET_SUCCESS } from '@peoplenet/vi-components-ui/src/actions/constants';
import {
  SAVE_REQUEST,
  SAVE_SUCCESS,
} from '@peoplenet/vi-components-ui/src/admin/settings/SettingsActionsType';
import {
  CUSTOMER_SETTINGS_FAILURE,
  CUSTOMER_SETTINGS_REQUEST,
  CUSTOMER_SETTINGS_SUCCESS,
} from './CustomerActionType';

const initialState = {
  loading: false,
  saving: false,
  saved: false,
  data: {},
};

export default (state = initialState, action) => {
  let item;
  const { type } = action;
  const { payload } = action;
  const settings = cloneDeep(get(payload, 'settings', null));
  const intelliview = cloneDeep(get(payload, 'intelliview', null));
  const blurringV2 = cloneDeep(get(payload, 'blurring_v2', null));
  const dataRetention = cloneDeep(get(payload, 'dataRetention', null));
  const sdCardRetentionV2 = cloneDeep(get(payload, 'sdCardRetention_v2', null));
  switch (type) {
    case SAVE_REQUEST:
      return {
        ...state,
        saved: false,
        saving: true,
        updatedAt: moment(),
      };
    case SAVE_SUCCESS:
      if (payload) {
        if (payload.oerList) {
          const excludedOER = [];
          forEach(payload.oerList, (value, key) => {
            if (value === false) {
              excludedOER.push(key);
            }
          });
          payload.excludedOER = excludedOER;
        }
      }
      return {
        ...state,
        saved: true,
        saving: false,
        data: {...state.data, settings, intelliview, 'blurring_v2': blurringV2, dataRetention, 'sdCardRetention_v2': sdCardRetentionV2},
        updatedAt: moment(),
        errorMessage: payload == null,
      };
    case GET_SUCCESS:
      item = payload || {};

      if (item.settings) {
        if (item.settings.oerList) {
          const excludedOER = [];
          forEach(item.settings.oerList, (value, key) => {
            if (value === false) {
              excludedOER.push(key);
            }
          });
          item.excludedOER = excludedOER;
        }

        // Initialize settings
        if (item.settings.overSpeed == null) {
          item.settings.overSpeed = 0;
        }
        if (item.settings.excessiveOverSpeed == null) {
          item.settings.excessiveOverSpeed = 0;
        }
        if (!item.settings.install) {
          item.settings.install = get(state, 'data.settings.install', {});
        }
      }

      return {
        ...state,
        data: item,
        loading: false,
        updatedAt: moment(),
        errorMessage: item == null,
      };
    case CUSTOMER_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        saved: false,
        saving: true,
      };
    case CUSTOMER_SETTINGS_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        loading: false,
        saved: true,
        saving: false,
        data,
      };
    }
    case CUSTOMER_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        saved: false,
        saving: false,
      };
    default:
      return state;
  }
};
